import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { CompareDrawer } from '@comparethemarketau/manor-compare-drawer';
import { getPathWithQueryString, pageContext } from 'ctm-util-functions';
import Immutable from 'immutable';

import { destructNumber, currencySymbol, decimalPoint } from '../products/common/number_formatter';
import { ProviderLogo } from '../products/common/provider_logo';
import { removeDispatchMapping } from '../../comparison/common/compare_store_mapping';
import { withSelectedProducts } from './common/with_selected_products';
import { paymentFrequencyStateMapping } from '../filters/common/filter_store_mapping';

const _PolicyCompareDrawerComponent = (props) => {
    const { selectedProducts, frequencyFilter, removeProduct } = props;

    const getPrice = (price) => {
        const totalPrice = (frequencyFilter === 'annual') ? price.getIn(['annualPremium']) : price.getIn(['monthlyPremium']);
        const formatedAmount = destructNumber(totalPrice);
        return (
            {
                prefix: currencySymbol,
                total: totalPrice,
                dollars: formatedAmount.dollars,
                separator: decimalPoint,
                cents: formatedAmount.cents
            }
        );
    };

    const compareList = () => {
        const list = selectedProducts.map((product) => {
            const providerCode = product.getIn(['providerMeta', 'code']);
            const name = product.getIn(['productMeta', 'name']);
            const id = product.getIn(['productMeta', 'id']);
            const excessPrice = product.getIn(['productMeta', 'excess']);

            return {
                productId: id,
                provider: {
                    logo: <ProviderLogo code={providerCode} isCustomerStyle />
                },
                productName: name,
                pricing: {
                    amount: getPrice(product.getIn(['productMeta', 'price'])),
                    excess: `Excess $${excessPrice}`
                }
            };
        });
        return list && list.toArray();
    };

    const handleClick = () => {
        pageContext.getProps().browserHistory.push(getPathWithQueryString('/car-insurance/journey/comparison'));
    };

    // The default zIndex from overlay is 30, so here we setted as theme.zIndex[20]
    return (
        <div className={classNames('test-policyCompareDrawer')}>
            <CompareDrawer
                id="theCompareDrawer"
                trackingLabel="Compare Drawer"
                compareNowClick={handleClick}
                onProductRemoved={(productId) => removeProduct(productId)}
                products={compareList()}
                zIndex={20}
            />
        </div>
    );
};

_PolicyCompareDrawerComponent.propTypes = {
    /**
     * withSelectedProducts
     */
    selectedProducts: PropTypes.instanceOf(Immutable.List),
    /**
     * paymentFrequencyStateMapping
     */
    frequencyFilter: PropTypes.string,
    /**
     * removeDispatchMapping
     */
    removeProduct: PropTypes.func
};

const PolicyCompareDrawerComponent = withSelectedProducts(connect(paymentFrequencyStateMapping, removeDispatchMapping)(_PolicyCompareDrawerComponent));

export { PolicyCompareDrawerComponent };
